export const data = [
  {
    sector: 'Department Stores',
    more: 7,
    less: -66
  },
  {
    sector: 'Luxury',
    more: 9,
    less: -52
  },
  {
    sector: 'Off-Price',
    more: 34,
    less: -26
  },
  {
    sector: 'Amazon Fashion',
    more: 37,
    less: -30
  },
  {
    sector: 'Secondhand',
    more: 44,
    less: -18
  }
];
